import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var StudentMetrics = require("lib/data/StudentMetrics");

var OrgActivityTable = require("components/data/org_reports/OrgActivityTable");
var Spinner = require("components/utility/Spinner");
var OrgTypes = require("lib/academic/OrgTypes");

var DataActions = require("lib/actions/DataActions");
var DataSelectors = require("lib/selectors/DataSelectors");

var RosterSelectors = require('lib/selectors/RosterSelectors');

function propsToConditions(props) {
	var conditions = _.pick(props, 
		"startDate", "endDate"
	);

	return conditions;
}

@connect(
	(state, props) => ({
		digests: DataSelectors.digestsByOrg({
			state,
			orgType: OrgTypes.SCHOOL_ORG,
			filters: { start_date: props.startDate, end_date: props.endDate },
		}),
		loading: DataSelectors.isLoadingDigests({ state }),
		schoolOrgs: RosterSelectors.schoolOrgs({ state })
	}),
	(dispatch, props) => ({
		populateData: () => {
			return dispatch((dispatch, getState) => {
				var query = {}
				if (!props.showGoals) {
					query.digest_embed = StudentMetrics.getDigestEmbeds(
						DataSelectors.dashboardOtherMetrics({
							state: getState(), count: 4, aggregate: true
						})
					)
				}
				return dispatch(DataActions.fetchDigests({
					conditions: propsToConditions(props), 
					query: query,
					cache: true
				}))
			})
		},
	})
)
@providePopulateData()
class DataSchoolActivity extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		if (this.props.loading) {
			var content = <Spinner placeholder scale={ 1.7 } />
		} else {
			var content = (
				<OrgActivityTable orgs={ this.props.schoolOrgs }
					orgType={ OrgTypes.SCHOOL_ORG }
					digests={ this.props.digests }
					reloadF={ this.props.populateData }
					onChangeView={ this.props.onChangeView } />
			);
		}

		return (
			<div className="dataSchoolActivity">
				{ content }
			</div>
		)
	}
}


DataSchoolActivity.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from above
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	orgType: PropTypes.string,
	onChangeView: PropTypes.func,

	// Data from @connect
	digests: PropTypes.array,
	schoolOrgs: PropTypes.array,
	loading: PropTypes.bool,

	// Handlers from @connect
	populateData: PropTypes.func,
})

module.exports = DataSchoolActivity;


// WEBPACK FOOTER //
// ./modules/components/data/org_reports/DataSchoolActivity.js